import uiCommonGetters from '@/store/ui/common/getters'

const getters = { ...uiCommonGetters }

export default getters
